import { themeBg, themeBorder, themeMuted, themeText } from '@/pages/reader/types';
import type { ReaderPrefs } from '@/pages/reader/types';

interface Props {
  prefs: ReaderPrefs;
  onChange: (p: Partial<ReaderPrefs>) => void;
  onClose: () => void;
}

export function ReaderSettings({ prefs, onChange, onClose }: Props) {
  const bg = themeBg(prefs.theme);
  const text = themeText(prefs.theme);
  const border = themeBorder(prefs.theme);
  const muted = themeMuted(prefs.theme);

  return (
    <div
      className="absolute right-2 top-12 z-40 w-56 rounded-xl p-4 shadow-xl"
      style={{ background: bg, border: `1px solid ${border}` }}
      onClick={e => e.stopPropagation()}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: muted }}>Reading</span>
        <button onClick={onClose} style={{ color: muted }}>✕</button>
      </div>
      <div className="mt-3 flex flex-col gap-3">
        <div>
          <label className="mb-1 block text-xs font-medium" style={{ color: text }}>Theme</label>
          <div className="flex overflow-hidden rounded-lg" style={{ border: `1px solid ${border}` }}>
            {(['light', 'sepia', 'dark'] as const).map(t => (
              <button key={t} onClick={() => onChange({ theme: t })}
                className="flex-1 py-1 text-xs capitalize transition-colors"
                style={prefs.theme === t
                  ? { background: '#2f3e46', color: '#ffffff' }
                  : { background: bg, color: text }
                }>
                {t}
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="mb-1 flex items-center justify-between text-xs font-medium" style={{ color: text }}>
            Font size <span style={{ color: muted }}>{prefs.fontSize}px</span>
          </label>
          <input type="range" min={13} max={22} step={1} value={prefs.fontSize}
            onChange={e => onChange({ fontSize: Number(e.target.value) })}
            className="w-full accent-[#2f3e46]" />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium" style={{ color: text }}>Typeface</label>
          <select value={prefs.fontFamily} onChange={e => onChange({ fontFamily: e.target.value as ReaderPrefs['fontFamily'] })}
            className="w-full rounded-md px-2 py-1 text-xs outline-none"
            style={{ background: bg, border: `1px solid ${border}`, color: text }}>
            <option value="Georgia">Georgia</option>
            <option value="Palatino">Palatino</option>
            <option value="System">System</option>
          </select>
        </div>
      </div>
    </div>
  );
}
